var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"layout"}},[_c('ModalDialog',_vm._g(_vm._b({attrs:{"full-bleed":true,"overlay":"light"}},'ModalDialog',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }